import {MutationTree} from 'vuex'
// @ts-ignore
import {IMaintenanceSearchParams, IMaintenanceState} from './maintenance-state.store'
// @ts-ignore
import * as _ from './maintenance-types.store'
import {ActivityStatus, CrudStatus} from '../../common/enums'
import {IEquipment} from '../../models/equipment/equipment.model'
import {
  EQUIPMENT_BLOCK,
  EQUIPMENT_PARAMETER,
  EQUIPMENT_SET_ATTRIBUTE_TO_EDIT,
  EQUIPMENT_SET_CURRENT_ATTRIBUTE,
  MAINTENANCE_SET_BY_FIELD
} from "./maintenance-types.store";
import { IMaintenance } from '../../models/maintenance/maintenance.model'
import { Pagination } from '../../models/generic'
import { ITemplateMaintenance } from '../../models/maintenance/template-maintenance.model'



export const mutations: MutationTree<IMaintenanceState> = {
  [_.EQUIPMENT_SET]: (state: IMaintenanceState, equipment: IEquipment) => {
    state.equipment = equipment
  },
  [_.MAINTENANCE_SET_ISLOADING]: (state: IMaintenanceState, val: boolean) => {
    state.isLoading = val
  },
  [_.EQUIPMENT_ACTION]: (state: IMaintenanceState, activityStatus: CrudStatus) => {
    state.crudActionStatus = activityStatus
  },
  [_.MAINTENANCE_SET_BY_FIELD]: (state: IMaintenanceState, payload: IMaintenance) => {
    state.maintenance = Object.assign({}, state.maintenance, {...payload})
  },
  [_.MAINTENANCE_TEMPLATE_SET_BY_FIELD]: (state: IMaintenanceState, payload: ITemplateMaintenance) => {
    state.maintenanceTemplate = Object.assign({}, state.maintenanceTemplate, {...payload})
  },
  [_.MAINTENANCE_INIT_FIELDS]: (state: IMaintenanceState) => {
    state.maintenance = {
      name:'',
      description:'',
      type:null,
      state:'enabled',
      method:'auto',
      fk_interval_type:null,
      interval:null,
      alert_pre_delay:null,
      fk_equipment:null,
      fk_entity_contractor:null,
      fk_entity_manager_assign:null,
      fk_attribute:null,
      fk_template:null,
      use_as_template:false,
      last_maintenance_date:new Date().toISOString().substr(0, 10),
      last_maintenance_value:null,
    }
  },
  [_.MAINTENANCE_TEMPLATE_INIT_FIELDS]: (state: IMaintenanceState) => {
    state.maintenanceTemplate = {
      name:'',
      description:'',
      type:null,
      fk_maint_interval_type:null,
      interval:null,
      alert_pre_delay:null,
      fk_maint_attribute:null,
      fk_character_problem:null,
      fk_character_problem_level_2:null
    }
  },
  [_.EQUIPMENT_SET_BY_FIELD]: (state: IMaintenanceState, payload: IEquipment) => {
    state.equipment = Object.assign({}, state.equipment, {...payload})
  },
  [_.EQUIPMENT_CURRENT_SET]: (state: IMaintenanceState, payload: any) => {
    state.currentEquipment = payload
  },
  [_.MAINTENANCE_SET_INTERVAL_TYPES]: (state: IMaintenanceState, payload: any) => {
    state.maintenanceIntervalTypes = payload
  },
  [_.MAINTENANCE_SET_TEMPLATES]: (state: IMaintenanceState, payload: any) => {
    state.maintenanceTemplates = payload
  },
  [_.MAINTENANCE_RESET_MAINTENANCES]: (state: IMaintenanceState, payload: any[]) => {
    state.maintenances = payload
  },
  [_.MAINTENANCE_SET_SEARCHPARAMS]: (state: IMaintenanceState, params: IMaintenanceSearchParams) => {
    state.maintenancesSearchParams = Object.assign({}, state.maintenancesSearchParams, {...params})//params
  },
  [_.MAINTENANCE_SET_MAINTENANCES]: (state: IMaintenanceState, payload: any[]) => {
    state.maintenances = payload
  },
  [_.EQUIPMENT_SET_EQUIPMENTS]: (state: IMaintenanceState, payload: any[]) => {
    state.equipments = payload
  },
  [_.EQUIPMENT_SET_ATTRIBUTE_TO_EDIT]: (state: IMaintenanceState, payload: { value: string }) => {
    state.attributeToEdit = payload
  },
  [_.EQUIPMENT_SET_CURRENT_ATTRIBUTE]: (state: IMaintenanceState, payload: { value: string }) => {
    state.currentAttribute = payload
  },
  [_.EQUIPMENT_PARAMETER]: (state: IMaintenanceState, payload: any) => {
    state.blockEquipmentParameter = Object.assign({}, state.blockEquipmentParameter, {...payload})
  },
  [_.EQUIPMENT_BLOCK]: (state: IMaintenanceState, payload: any) => {
    state.blockEquipmentData = Object.assign({}, state.blockEquipmentData, {...payload})
  },
  [_.VEHICLE_FLEET_PARAMETER]: (state: IMaintenanceState, payload: any) => {
    state.blockVehicleFleetParameter = Object.assign({}, state.blockVehicleFleetParameter, {...payload})
  },
  [_.VEHICLE_FLEET_BLOCK]: (state: IMaintenanceState, payload: any) => {
    state.blockVehicleFleet = Object.assign({}, state.blockVehicleFleet, {...payload})
  }
}



// WEBPACK FOOTER //
// ./src/store/maintenance/maintenance-mutations.store.ts